import fadeInEls from './fadeInEls.js';

export default (scroller) => {
    const portfolioHero = document.querySelector(".portfolio-hero");

    if (portfolioHero) {
        const filterButtons = document.querySelectorAll('.filter-list-item button');
        const filterLists = document.querySelectorAll('.filter-list-sublist');
        const scrollContainer = document.querySelector('[data-scroll-container]');
        const portfolioFilter = document.querySelector('.filter-wrapper');
        const filterBlock = document.querySelector('.filter__block');
        const filterSubtitles = document.querySelectorAll('.filter__subtitle');
        
        // Keep track of original parents
        const originalParents = new Map();
        for (const list of filterLists) {
            originalParents.set(list, list.parentElement);
        }

        // Close all dropdowns and restore their original position
        const closeAllDropdowns = () => {
            for (const btn of filterButtons) {
                btn.setAttribute('aria-expanded', 'false');
                btn.closest('.filter-list-item').classList.remove('active');
            }
            for (const list of filterLists) {
                list.classList.remove('open');
                // Move back to original parent if it was moved
                const originalParent = originalParents.get(list);
                if (list.parentElement !== originalParent) {
                    originalParent.appendChild(list);
                }
            }
        };

        // Close dropdowns when clicking outside
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.filter-list-item')) {
                closeAllDropdowns();
            }
        });

        const updateDropdownPosition = (button, sublist) => {
            const rect = button.getBoundingClientRect();
            
            // Move sublist to scroll container if not already there
            if (sublist.parentElement !== scrollContainer) {
                scrollContainer.appendChild(sublist);
            }

            // Position dropdown below button
            sublist.style.position = 'fixed';
            sublist.style.top = `${rect.bottom}px`;
            sublist.style.left = `${rect.left}px`;
            sublist.style.minWidth = `${rect.width}px`;
            sublist.style.zIndex = '9999';
        };

        // Handle dropdown toggles
        for (const button of filterButtons) {
            button.addEventListener('click', (e) => {
                e.stopPropagation();
                
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                const sublist = button.nextElementSibling;
                const listItem = button.closest('.filter-list-item');
                
                // Close all dropdowns first
                closeAllDropdowns();

                if (!isExpanded) {
                    // Open this dropdown
                    button.setAttribute('aria-expanded', 'true');
                    listItem.classList.add('active');
                    
                    // Update scroller first
                    scroller?.update();
                    
                    // Then show and position dropdown
                    setTimeout(() => {
                        updateDropdownPosition(button, sublist);
                        sublist.classList.add('open');
                    }, 0);
                }
            });
        }

        // Update dropdown positions on scroll
        scroller.on('scroll', () => {
            const openButton = document.querySelector('.filter-list-item button[aria-expanded="true"]');
            if (openButton) {
                const sublist = document.querySelector('.filter-list-sublist.open');
                if (sublist) {
                    updateDropdownPosition(openButton, sublist);
                }
            }
        });

        // Handle filter subtitle toggles
        for (const subtitle of filterSubtitles) {
            subtitle.addEventListener('click', () => {
                const isExpanded = subtitle.getAttribute('aria-expanded') === 'true';
                const list = subtitle.nextElementSibling;
                
                // Toggle this list
                subtitle.setAttribute('aria-expanded', !isExpanded);
                list.classList.toggle('open');
                
                // Update scroller
                setTimeout(() => {
                    scroller?.update();
                }, 0);
            });
        }
    }
};
